import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { PRESS_EMAIL, PRESS_EMAIL_SUBJECT as EMAIL_SUBJECT, PRESS_EMAIL_BODY as EMAIL_BODY, PRESS_MAILTO } from "../data/pressEmail";

const C = { deep: "#042F2E", teal: "#068fa2", gold: "#b8924f", cream: "#efeae7" };

const CREDENTIALS = [
  "Radio Broadcast veteran. 15-year creator, builder, and host of a Live International Radio show broadcast from KKNW Seattle, WA.",
  "Twenty-plus years in Mind Body Spirit Research and Development.",
  "HeartMath Certified Practitioner.",
  "Evidential medium and intuitive. Holding space for those who have crossed over. Communicating with individuals in comas.",
  "Three years traveling the world as a Team Leader and Activity Leader. Held space for thousands of participants in their own healing.",
  "Healing POD work. Energy modalities including Reiki, The Reconnection and 111.",
  "Three years trained with a renowned meditation teacher.",
  "Founder, Mind Body Spirit HYGIENE™ Method.",
  "Creator, A.C.T. NOW Method™ — Awareness, Clarity, Tapped In, No Opportunity Wasted.",
  'Author, "Stop Saying \'I Have To.\' Start Living \'I GET TO.\'" (2026) — in two editions, for women and for anyone.',
];

const TOPICS = [
  "Why I named it hygiene. The new language reshaping the wellness conversation.",
  "The Kitchen Trash Moment. How three words at 6 AM rewrote a 20-plus-year search.",
  "Brought down to the studs. Who can relate? Why this method works.",
  "I GET TO vs. I Have To. The language that either heals you or eats you alive.",
  "The A.C.T. NOW Method™. A framework for rebuilding from the studs.",
  "The Personal Code of Conduct (PCC). Non-negotiables for yourself, by yourself.",
  "The Messy Middle. Real language for divorce, estrangement, grief, and midlife reckoning.",
  "The end of toxic positivity, spiritual bypass, and identity gatekeeping.",
  "Free will and Divine discernment without religion, without gurus, without bypass.",
  "Why you cannot outsource your own hygiene. The reader does the work.",
  "I wrote it for women. Then men asked. What happens when the people you did not write for tell you it is theirs.",
];

const Label = ({ children }) => (
  <p className="font-sans uppercase font-semibold mb-1.5" style={{ color: C.gold, fontSize: "7.5pt", letterSpacing: "0.3em" }}>
    {children}
  </p>
);

const Header = () => (
  <header className="pb-3 mb-3" style={{ borderBottom: `1.5px solid ${C.gold}` }} data-testid="press-kit-header">
    <p className="font-sans uppercase" style={{ color: C.teal, fontSize: "7.5pt", letterSpacing: "0.4em" }}>Press Kit</p>
    <h1 className="font-serif leading-none mt-1" style={{ color: C.deep, fontSize: "30pt" }}>Temple Franklin</h1>
    <p className="font-serif italic mt-1" style={{ color: C.teal, fontSize: "12pt" }}>Founder, Mind Body Spirit HYGIENE™ Method</p>
    <p className="font-sans uppercase mt-1" style={{ color: C.gold, fontSize: "7.5pt", letterSpacing: "0.25em" }}>
      Radio Broadcast Veteran · Evidential Medium · Author
    </p>
  </header>
);

const BookAndCourse = () => (
  <section className="mb-3" data-testid="press-kit-book">
    <Label>The Book</Label>
    <p className="font-serif" style={{ fontSize: "10.5pt" }}>
      Stop Saying <em>"I Have To."</em> Start Living <em>"I GET TO."</em> — The Mind Body Spirit HYGIENE™ Method
    </p>
    <p className="font-sans mt-0.5" style={{ fontSize: "8pt" }}>
      Paperback · 5.5 × 8.5 · 141 pages · $19.99 · ISBN 979-8-9964172-0-9<br />
      Available now · Instant PDF at mindbodyspirithygienetools.com, $9.99 · Paperback $19.99 from Amazon, Barnes & Noble, Lulu and Ingram
    </p>
    <p className="font-serif mt-1.5" style={{ fontSize: "9pt" }}>
      <strong>Two editions.</strong> I wrote it for women. That is what you are told to do — pick your niche, speak to one person. So I did. Then men started telling me it was theirs too. So there are two now. The original, in the language I first wrote it in. And a second with the door opened wider — the same book, the same tools, the same practice.
    </p>
    <p className="font-serif mt-1.5" style={{ fontSize: "9pt" }}>
      <strong>The course.</strong> Build Your Own: Mind Body Spirit HYGIENE™ — twenty-three short lessons, a pen, and a practice that ends up being yours. $33. Printable pages and an online practice together.
    </p>
  </section>
);

const List = ({ items, numbered, testid }) => (
  <ul className="font-serif space-y-0.5" style={{ fontSize: "8.5pt", lineHeight: 1.3 }} data-testid={testid}>
    {items.map((t, i) => (
      <li key={i} className="flex gap-1.5">
        <span className="font-sans font-semibold shrink-0" style={{ color: C.gold, minWidth: numbered ? "1.3em" : "0.8em" }}>
          {numbered ? String(i + 1).padStart(2, "0") : "✦"}
        </span>
        <span>{t}</span>
      </li>
    ))}
  </ul>
);


const QUOTES = [
  "You don't outsource brushing your teeth. You don't outsource your personal hygiene either.",
  "This is hygiene. Daily. Non-negotiable. Yours. How you define it.",
  "Real tools, for real women, in the messy middle.",
];

const Quotes = () => (
  <section className="mt-3" data-testid="press-kit-quotes">
    <Label>Signature Quotes</Label>
    <div className="space-y-1">
      {QUOTES.map((q, i) => (
        <p key={i} className="font-serif italic pl-3" style={{ fontSize: "9.5pt", borderLeft: `2px solid ${C.gold}` }}>"{q}"</p>
      ))}
    </div>
  </section>
);

const Contact = () => (
  <footer className="mt-3 pt-2.5 text-center font-sans" style={{ borderTop: `1.5px solid ${C.gold}`, fontSize: "9pt" }} data-testid="press-kit-contact">
    <p className="uppercase font-semibold" style={{ color: C.gold, fontSize: "7.5pt", letterSpacing: "0.3em" }}>Contact & Booking</p>
    <p className="mt-1" style={{ color: C.deep }}>
      mindbodyspirithygiene@gmail.com · mindbodyspirithygienetools.com/media-inquiries · @TempleFranklin
    </p>
  </footer>
);



const EmailTemplate = () => {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(`Subject: ${EMAIL_SUBJECT}\n\n${EMAIL_BODY}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <section className="max-w-[8.5in] mx-auto mt-8 bg-white p-8 shadow-xl print:hidden" style={{ color: C.deep }} data-testid="press-email-template">
      <Label>Booking email template</Label>
      <p className="font-sans text-sm mb-1"><strong>To:</strong> {PRESS_EMAIL}</p>
      <p className="font-sans text-sm mb-3" data-testid="press-email-subject"><strong>Subject:</strong> {EMAIL_SUBJECT}</p>
      <pre className="font-serif text-base whitespace-pre-wrap p-4 rounded-lg" style={{ background: C.cream }} data-testid="press-email-body">{EMAIL_BODY}</pre>
      <div className="flex gap-3 mt-4">
        <button onClick={copy} className="rounded-full px-5 py-2 font-sans font-semibold text-sm text-white transition-opacity hover:opacity-90" style={{ background: C.teal }} data-testid="press-email-copy-btn">
          {copied ? "Copied" : "Copy email"}
        </button>
        <a href={PRESS_MAILTO} className="rounded-full px-5 py-2 font-sans font-semibold text-sm border transition-colors hover:bg-[#efeae7]" style={{ borderColor: C.teal, color: C.teal }} data-testid="press-email-open-btn">
          Open in email
        </a>
      </div>
    </section>
  );
};

export default function PressKit() {
  const isLive = window.location.hostname.endsWith("mindbodyspirithygienetools.com");
  useEffect(() => {
    document.title = "Press Kit — Temple Franklin";
    let m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement("meta"); m.setAttribute("name", "robots"); document.head.appendChild(m); }
    m.setAttribute("content", "noindex, nofollow");
  }, []);

  if (isLive) return <Navigate to="/media-inquiries" replace />;

  return (
    <div className="min-h-screen py-10 bg-[#efeae7] print:py-0 print:min-h-0 print:bg-white" data-testid="press-kit-page">
      <style>{"@page { size: letter; margin: 0.45in; } @media print { body { background: white; } }"}</style>
      <div className="max-w-[8.5in] mx-auto mb-5 flex justify-end print:hidden px-4">
        <button onClick={() => window.print()} className="rounded-full px-6 py-2.5 font-sans font-semibold text-sm text-white transition-colors hover:opacity-90" style={{ background: C.teal }} data-testid="press-kit-print-btn">
          Print / Save as PDF
        </button>
      </div>
      <article className="bg-white mx-auto shadow-xl w-[8.5in] min-h-[11in] p-[0.45in] print:shadow-none print:w-auto print:min-h-0 print:p-0" style={{ color: C.deep }} data-testid="press-kit-sheet">
        <Header />
        <section className="mb-3" data-testid="press-kit-about">
          <Label>About Temple</Label>
          <p className="font-serif" style={{ fontSize: "9pt", lineHeight: 1.4 }}>
            Temple Franklin is a Radio Broadcast veteran. For fifteen years she created, built, and hosted her own Live International Radio show broadcast from KKNW Seattle, WA — which is to say, she has spent half her life on the other side of the microphone, asking the questions producers wish their guests would answer.
          </p>
        </section>
        <BookAndCourse />
        <div className="grid grid-cols-2 gap-5">
          <section><Label>Credentials</Label><List items={CREDENTIALS} testid="press-kit-credentials" /></section>
          <section><Label>Speaking & Interview Topics</Label><List items={TOPICS} numbered testid="press-kit-topics" /></section>
        </div>
        <Quotes />
        <Contact />
      </article>
      <EmailTemplate />
    </div>
  );
}
